import { defineAsyncComponent } from 'vue'
export default {
  "logged-in-app": defineAsyncComponent(() => import("/opt/build/repo/layouts/logged-in-app.vue").then(m => m.default || m)),
  "logged-out-fullscreen": defineAsyncComponent(() => import("/opt/build/repo/layouts/logged-out-fullscreen.vue").then(m => m.default || m))
}